var React = require('react');

function CheckScallop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.89,8.49,15,7l.56-1.67a.51.51,0,0,0-.25-.62l-1.55-.87-.31-1.73a.36.36,0,0,0-.25-.43.24.24,0,0,0-.12,0L11.3,1.61,10.25.19A.48.48,0,0,0,9.63.06L8,.8,6.41.06a.49.49,0,0,0-.62.13l-1,1.42L3,1.68a.51.51,0,0,0-.5.43L2.26,3.84.71,4.71a.57.57,0,0,0-.25.62L1,7,.09,8.49a.46.46,0,0,0,.06.62l1.24,1.24-.13,1.74a.47.47,0,0,0,.38.5l1.67.5L4,14.7a.47.47,0,0,0,.56.3l1.73-.37,1.37,1.12a.46.46,0,0,0,.62,0l1.36-1.12,1.74.37a.43.43,0,0,0,.55-.29v0l.69-1.61,1.67-.5a.52.52,0,0,0,.37-.5l-.12-1.73,1.24-1.24C16,8.93,16.08,8.68,15.89,8.49ZM6.94,12,3.69,8.75,5,7.4l1.9,1.91,4.82-4.82,1.35,1.35Z"}));
}

CheckScallop.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 16 15.87"};

module.exports = CheckScallop;

CheckScallop.default = CheckScallop;
